import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a double bed (1.6 x 2.0, length along Z, headboard at -Z):
// oak frame and headboard, white duvet, folded blanket strip, two pillows.
const OAK = "#c8975a";
const WALNUT = "#7a5a3a";
const DUVET = "#f2efe8";
const BLANKET = "#8a9aa8";
const PILLOW = "#e8e4dc";

export const bedDouble = defineModel({
  id: "bed-double",
  batchId: "modern",
  name: "Bed (double)",
  tags: ["modern", "interior", "furniture", "bedroom", "bed"],
  summary: "A double bed with an oak frame, white duvet and two pillows.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // legs
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [-0.72, 0.06, -0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [0.72, 0.06, -0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [-0.72, 0.06, 0.92] },
      { geometry: new THREE.BoxGeometry(0.08, 0.12, 0.08), color: WALNUT, position: [0.72, 0.06, 0.92] },
      // frame
      { geometry: new THREE.BoxGeometry(1.6, 0.22, 2.0), color: OAK, position: [0, 0.23, 0] },
      // headboard at -Z
      { geometry: new THREE.BoxGeometry(1.6, 0.8, 0.08), color: OAK, position: [0, 0.7, -0.96] },
      // duvet slab
      { geometry: new THREE.BoxGeometry(1.5, 0.2, 1.84), color: DUVET, position: [0, 0.44, 0.02] },
      // folded blanket strip at the foot
      { geometry: new THREE.BoxGeometry(1.52, 0.07, 0.55), color: BLANKET, position: [0, 0.575, 0.62] },
      // pillows
      { geometry: new THREE.BoxGeometry(0.62, 0.13, 0.38), color: PILLOW, position: [-0.38, 0.6, -0.7], rotation: [-0.15, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.62, 0.13, 0.38), color: PILLOW, position: [0.38, 0.6, -0.7], rotation: [-0.15, 0, 0] },
    ];
  },
  animations: [],
});
